import React, { useState } from "react";
import { useForm } from "react-hook-form";

import VtrgInnerBlockForm from '../vtrg_inner_block/vtrg_inner_block_form.jsx';
import VtrgVideoForm from '../vtrg_video/vtrg_video_form.jsx';
import cancelPieceForm from '../cancel_piece_form';

const VtrgCustomBlockForm = ({
  data,
  instanceType,
  instanceId,
  pieceType,
  slot,
  updatePiece,
  setActionLoading,
  ordn,
  afterUpdateVtrgPiece,
  getPieceForm,
}) => {
  const [successMsg, setSuccessMsg] = useState(null);
  const [whichFormShow, setWhichFormShow] = useState(data && data.block_type ? data.block_type : '');
  const [errorMsg, setErrorMsg] = useState(null);
  const [disableBtns, setDisableBtns] = useState(false);
  const [values, setValues] = useState({
    block_type: data && data.block_type ? data.block_type : ""
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const afterUpdateVtrgPieceCustomBlock = data => {
    console.log(` afterUpdate vtrgPieceCustomBlock ${data}`);
    // Без data вызывается при отмене редактирования — пробрасываем, чтобы вернуть панель управления блоком
    if (data || slot) {
      afterUpdateVtrgPiece(data)
    }
  };
  
  const updatePieceCustomBlock = data => {
    updatePiece(data)
  };

  const setActionLoadingCustomBlock = data => {
    setActionLoading(data)
  };
  
  const getPieceFormCustomBlock = data => {
    getPieceForm(data)
  };

  return (
    <div className="vtrg-edit-body">
      <h3>Блок видео:</h3>
      <fieldset className="inputs">
        <select
          name="vitrage_pieces_vtrg_custom_block[block_type]"
          onChange={(ev) => {
            setWhichFormShow(parseInt(ev.target.value));
          }}
        >
          <option value="" selected={true}></option>
          <option
            value="1"
            selected={whichFormShow === 1}
          >
            Видео во весь экран
          </option>
          <option
            value="2"
            selected={whichFormShow === 2}
          >
            Видео с отступами
          </option>
          <option
            value="3"
            selected={whichFormShow === 3}
          >
            2 блока
          </option>
        </select>
      </fieldset>
      {(whichFormShow === 1) ? 
        <VtrgVideoForm 
          data={data}
          instanceType={instanceType}
          instanceId={instanceId}
          pieceType={pieceType}
          slot={slot} 
          updatePiece={updatePieceCustomBlock}
          setActionLoading={setActionLoadingCustomBlock}
          ordn={ordn}
          afterUpdateVtrgPiece={afterUpdateVtrgPieceCustomBlock}
          getPieceForm={getPieceFormCustomBlock}
          blockType={1} />
        : <></>
      }
      { (whichFormShow === 2) ? 
        <VtrgVideoForm 
          data={data}
          instanceType={instanceType}
          instanceId={instanceId}
          pieceType={pieceType}
          slot={slot} 
          updatePiece={updatePieceCustomBlock}
          setActionLoading={setActionLoadingCustomBlock}
          ordn={ordn}
          afterUpdateVtrgPiece={afterUpdateVtrgPieceCustomBlock}
          getPieceForm={getPieceFormCustomBlock}
          blockType={2} />
        : <></>
      }
      {(whichFormShow === 3) ?  <>
        <VtrgInnerBlockForm 
          data={data}
          instanceType={instanceType}
          instanceId={instanceId}
          pieceType={pieceType}
          slot={slot} 
          updatePiece={updatePieceCustomBlock}
          setActionLoading={setActionLoadingCustomBlock}
          ordn={ordn}
          afterUpdateVtrgPiece={afterUpdateVtrgPieceCustomBlock}
          getPieceForm={getPieceFormCustomBlock}
          blockType={3} />
        </>
        : <></>
      }
      {/* Пока тип не выбран, своих кнопок у вложенной формы нет — даём возможность отменить */}
      {!whichFormShow && (
        <fieldset className="actions">
          <input
            type="reset"
            value="Отмена"
            onClick={() =>
              cancelPieceForm({ slot, updatePiece, afterUpdateVtrgPiece, getPieceForm })
            }
          />
        </fieldset>
      )}
    </div>
  );
};

export default VtrgCustomBlockForm;
